import { useCallback, useEffect, useRef, useState } from 'react';

// Successful daily jobs are permanent; failed jobs need an explicit retry.
export default function useDailyShiftImport(api, {enabled, boutique, date, onImported}) {
  const [state, setState] = useState(null);
  const imported = useRef(onImported);
  imported.current = onImported;
  const generation = useRef(0);
  const [attempt, setAttempt] = useState(0);
  const retry = useCallback(() => setAttempt(value => value + 1), []);
  useEffect(() => {
    const token = ++generation.current;
    if (!enabled) { setState(null); return undefined; }
    let timer;
    let collecting = false;
    const active = () => token === generation.current;
    const update = async (first = false) => {
      try {
        const response = first
          ? await api.post('/schedules/zenoti/daily-collection', null, {params:{boutique, retry:attempt > 0}})
          : await api.get('/schedules/zenoti/daily-collection', {params:{boutique}});
        if (!active()) return;
        if (response.data.date !== date) { setState(null); return; }
        const job = response.data.job;
        setState(job);
        if (job?.status === 'collecting') {
          collecting = true;
          timer = setTimeout(() => update(), 3000);
        } else if (job?.status === 'succeeded' && collecting) {
          imported.current?.();
        }
      } catch (error) {
        if (active()) setState({status:'failed', message:error.response?.data?.detail || 'Shifts could not be collected. Previous schedule retained.', needsConnection:error.response?.status === 409});
      }
    };
    update(true);
    return () => { generation.current += 1; clearTimeout(timer); };
  }, [api, enabled, boutique, date, attempt]);
  return {state, retry};
}
